// 获取a标签带有 data-eshop-href 或 data-solution-href 的元素，并根据环境赋值href
$(function () {
    $('[data-eshop-href]').each(function () {
        var self=$(this);
        self.attr('href', eshop_host + self.attr('data-eshop-href'));
    });

    $('[data-solution-href]').each(function () {
        var self=$(this);
        self.attr('href', solution_host + self.attr('data-solution-href'));
    })

    $('[data-m-solution-href]').each(function () {
        var self=$(this);
        self.attr('href', solution_m_host + self.attr('data-m-solution-href'));
    })
});